import { useEffect } from "react";
import { useWebSocket } from "./WebSocketProvider";

type Handlers = Record<string, (payload: never, id?: number) => void>;

export function useChannel(channel: string | null | undefined, handlers: Handlers): void {
  const { subscribe } = useWebSocket();
  useEffect(() => {
    if (!channel) return;
    const unsub = subscribe(channel, (eventType, payload, id) => {
      const h = handlers[eventType];
      if (h) h(payload as never, id);
    });
    return unsub;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [channel, subscribe]);
}
